const AuthStatusEnum = {
  started: "started",
  success: "success",
  failed: "failed",
};

export { AuthStatusEnum };
